export const Services = {
    ADDRESS_VALIDATION: 'addressValidation',
    AST_DEALER_SERVICES: 'astDealerServices',
    AST_DEALER_MOBILITY: 'astDealerMobility',
    BBO: 'bbo',
    BUILDABILITY: 'buildability',
    CARLINES: 'carlines',
    CATALOGUE_OVERVIVEW: 'catalogueOverview',
    CONSTRAINTS: 'constraints',
    POPULAR_FEATURES: 'polularFeatures',
    DEBUG_INFO: 'debugInfo',
    CUSTOMER_ACTIONS: 'customerActions',
    DATA_VERSION: 'dataVersion',
    DEALERS_BY_TENANT: 'dealersByTenant',
    DEALERS_BY_POSTAL_CODE: 'dealersByPostalCode',
    DEALER_BY_ID_WITH_DETAILS: 'dealerByIdWithDetails',
    DEALER_COMMENTS: 'dealerComments',
    DEALER_RESULTS: 'dealerResults',
    EMAIL_SEND: 'emailSend',
    EMAIL_VALIDATE_ADDRESS: 'emailValidateAddress',
    EMAIL_VALIDATE_TEXT: 'emailValidateText',
    EMISSION_CONSUMPTION: 'emissionConsumption',
    FORM_DEFINITION: 'formDefinition',
    FORM_SUBMIT: 'formSubmit',
    I18N: 'i18n',
    INVENTORY_STOCK: 'getInventoryStock',
    MINIFY: 'minify',
    EXPAND: 'expand',
    LOCATE_MY_POSTCODE: 'locateMyPostcode',
    MEDIA_IMAGES: 'mediaImages',
    MODEL: 'model',
    MODEL_DETAIL: 'modeldetail',
    PAYMENT_AUTHORIZATION: 'getTransactionId',
    PAYMENT_CREDENTIALS: 'getSecurityToken',
    PCS: 'pcs',
    QUESTIONS: 'questions',
    REALTIME_RENDERING: 'realtimeRendering',
    RECOMMENDATIONS: 'recommendations',
    RETREIVE_CONFIGURATION: 'retreiveConfiguration',
    SDS_DATA_VERSION: 'sdsDataVersion',
    SPECIAL_OFFERS: 'specialOffers',
    STORE_CONFIGURATION: 'storeConfiguration',
    TENANT_CONFIG: 'tenantConfig',
    VICCI_VCS_CONSOLIDATED_DATA: 'vicciVcsConsolidatedData',
    VICCI_VCS_EXPANDED_CONFIGURATION: 'vicciVcsExpandedConfiguration',
    VICCI_VCS_FEATURES_AND_COLORS: 'vicciVcsFeaturesAndColors',
    VICCI_VCS_START_CONFIGURATION: 'vicciVcsStartConfiguration',
    VICCI_VCS_MEDIA_ASSETS: 'vicciVcsMediaAssets',
    VICCI_VCS_TENANT_DATA_VERSION: 'vicciVcsTenantDataVersion',
    VICCI_VIS_CARLINES: 'vicciVisCarlines',
    VICCI_VIS_TRIMS: 'vicciVisTrims',
    VICCI_VIS_MODEL: 'vicciVisModel',
    VICCI_VIS_MODEL_FEATURES: 'vicciVisModelFeatures',
    VICCI_VIS_CUSTOMER_ACTIONS: 'vicciVisCustomerActions',
    VICCI_VIS_SPECIAL_OFFERS: 'vicciVisSpecialOffers',
    VICCI_VIS_TENANT_DATA_VERSION: 'vicciVisTenantDataVersion',
    VICCI_VGS_SAVE_STORAGE: 'vicciVgsSaveStorage',
    VICCI_VGS_LOAD_STORAGE: 'vicciVgsLoadStorage',
    VICCI_PCS_CARLINES: 'vicciPcsCarlines',
    VICCI_PCS_TRIMS: 'vicciPcsTrims',
    VICCI_PCS_CONFIGURATION: 'vicciPcsConfiguration',
    VTP: 'vtp',
};
